export const DAILY_LIMIT_EXCEEDED_DIALOG = 'DailyLimitExceededDialog';
export const DISCONNECTED_FOR_INACTIVITY_DIALOG = 'DisconnectedForInactivityDialog';
export const DISCONNECTED_FROM_OPERATOR_DIALOG = 'DisconnectedFromOperatorDialog';
export const DISCONNECTED_SESSION_DIALOG = 'DisconnectedSessionDialog';
export const GENERIC_DIALOG = 'GenericDialog';
export const GEOLOCATION_ERROR_DIALOG = 'GeolocationErrorDialog';
export const LOW_BALANCE_DIALOG = 'LowBalanceDialog';
export const LOW_REAL_BALANCE_DIALOG = 'LowRealBalanceDialog';
export const NO_VIDEO_DIALOG = 'NoVideoDialog';
export const OPERATOR_ERROR_DIALOG = 'OperatorErrorDialog';
export const REALITY_CHECK_DIALOG = 'RealityCheckDialog';
export const RECONNECTING_SOCKET_DIALOG = 'ReconnectingSocketDialog';
export const REGULATIONS_DIALOG = 'RegulationsDialog';
export const REGULATIONS_OSS_DIALOG = 'RegulationsOSSDialog';
export const TABLE_CLOSED_DIALOG = 'TableClosedDialog';
export const UKGC_DIALOG = 'UKGC_DIALOG';
export const VIDEO_ERROR_DIALOG = 'VideoErrorDialog';
export const RETAIL_ROUND_CANCELED_DIALOG = 'RetailRoundCanceledDialog';
export const RECONNECTING_SCREEN_DIALOG = 'ReconnectingSocketScreen';
export const PLAYER_NR_TABLE_LIMIT_REACHED_DIALOG = 'PlayerNrTableLimitReachedDialog';
export const WELCOME_DIALOG = 'WelcomeDialog';
export const BONUS_WHEEL_INSUFFICIENT_BALANCE_DIALOG = 'BonusWheelInsufficientBalanceDialog';
export const BONUS_WHEEL_TUTORIAL_DIALOG = 'BonusWheelTutorialDialog';

// retail game specific
export const VIDEO_MANIFEST_ERROR_DIALOG = 'VideoManifestErrorDialog';

export const DIALOG_PRIORITIES = {
  [DAILY_LIMIT_EXCEEDED_DIALOG]: 1,
  [DISCONNECTED_FROM_OPERATOR_DIALOG]: 1,
  [GEOLOCATION_ERROR_DIALOG]: 1,
  [REALITY_CHECK_DIALOG]: 1,
  [REGULATIONS_DIALOG]: 1,
  [REGULATIONS_OSS_DIALOG]: 1,
  [UKGC_DIALOG]: 1,
  [PLAYER_NR_TABLE_LIMIT_REACHED_DIALOG]: 1,

  [DISCONNECTED_FOR_INACTIVITY_DIALOG]: 2,
  [DISCONNECTED_SESSION_DIALOG]: 2,
  [GENERIC_DIALOG]: 2,
  [LOW_BALANCE_DIALOG]: 2,
  [LOW_REAL_BALANCE_DIALOG]: 2,
  [OPERATOR_ERROR_DIALOG]: 2,
  [RECONNECTING_SOCKET_DIALOG]: 2,
  [TABLE_CLOSED_DIALOG]: 2,
  [WELCOME_DIALOG]: 2,

  [NO_VIDEO_DIALOG]: 3,
  [VIDEO_ERROR_DIALOG]: 3,
  [VIDEO_MANIFEST_ERROR_DIALOG]: 3,
  [RETAIL_ROUND_CANCELED_DIALOG]: 3,
  [RECONNECTING_SCREEN_DIALOG]: 3,
  [BONUS_WHEEL_TUTORIAL_DIALOG]: 3,
  [BONUS_WHEEL_INSUFFICIENT_BALANCE_DIALOG]: 3,
} as const;
